<template>
  <div class="project">
    <myTitle til="新建项目"></myTitle>
    <div class="main">
      <div class="nav" v-if="true">
        <div class="upClass">
          <span>1</span> 上传文件
        </div>
        <div>
          <img src="../../assets/imgs/project/next_step_normal.png" alt />
        </div>

        <div :class="isClass ? '' : 'upClass'">
          <span>2</span> 上传设置
        </div>
      </div>
      <keep-alive :include="['file']">
      <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import myTitle from "@/common/title.vue";

export default {
  name: "home",
  beforeRouteUpdate(to, from, next) {
    if (to.name==="fileSet") {
      this.isClass = false
    } else {
      this.isClass = true
    }
    next();
  },
  data () {
    return {
      keepAlive:true,
      isClass: true
    };
  },
  components: {
    myTitle
  },
};
</script>
<style lang="less" scoped>
.project {
  height: 100%;
  // margin: 30px;
  .main {
    // width: 1660px;
    //min-height: 734px;
    height: calc(100% - -11px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 5px;
  }
  .nav {
    text-align: left;
    height: 46px;
    border-bottom: 1px rgba(241, 241, 241, 1) solid;
    padding-left: 20px;
    div:nth-child(2) {
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div {
      float: left;
      margin-top: 10px;
      width: 124px;
      height: 36px;
      border-radius: 4px 4px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      // background: rgba(87, 122, 188, 1);
      // color: rgba(255, 255, 255, 1);
      // background: transparent;
      color: rgba(128, 128, 128, 1);
      span {
        display: inline-block;
        background: rgba(228, 228, 228, 1);
        border-radius: 50%;
        height: 16px;
        width: 16px;
        margin-top: 8px;
        color: rgba(155, 155, 155, 1);
        font-size: 14px;
        line-height: 16px;
      }
    }
    .upClass {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      span {
        // background: rgba(255, 255, 255, 1);
        color: rgba(51, 51, 51, 1);
        background: rgba(228, 228, 228, 1);
        border-radius: 50%;
      }
    }
    //   .navRi {
    //     background: transparent;
    //     color:rgba(87,122,188,1);
    //       span{
    // background:rgba(224,237,252,1);
    //   }
    //   }
  }
}
</style>